import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentoDet } from 'src/app/models/DocumentoDet';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog } from '@angular/material';
import { Catalogo } from 'src/app/models/Catalogo';
import { CatalogoService } from 'src/app/services/Catalogo.service';
import { NumIdTipCatCargTipoDest, iconVer, iconEditar, iconEliminar, NumIdTipCatDocSeguimiento, DscTituloPaginator, openModalMensajePrg, strDscMsjPrgEliminar, CodSubTipoFichaCAR, CodSubTipoFichaDOC, CodTipoFichaHe, ConvertStrDateToFormatBD, ConvertDateTimeToStr, isNotEmptyList } from 'src/app/general/variables';
import { MedioNotifService } from 'src/app/services/med-notif.service';
import { MedioNotif } from 'src/app/models/MedioNotif';
import { ModalRegCargoComponent } from '../../evalinf-regfur/modal-reg-cargo/modal-reg-cargo.component';

@Component({
  selector: 'app-documentos-emitidos',
  templateUrl: './documentos-emitidos.component.html',
  styleUrls: ['./documentos-emitidos.component.css']
})
export class DocumentosEmitidosComponent implements OnInit {

  flgSoloLectura: string;
  listDocumentoDet: DocumentoDet[] = [];
  listTipoDestinatario: Catalogo[] = [];
  listMedioNotif: MedioNotif[] = [];
  listSeguimiento: Catalogo[] = [];
  isNotEmptyList = isNotEmptyList;

  iconVer = iconVer;
  iconEditar = iconEditar;
  iconEliminar = iconEliminar;

  dataSource: MatTableDataSource<DocumentoDet>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  matTableColumnsDef = ['item', 'nombre', 'fechahora', 'tipodest', 'fechaemi', 'mediocom', 'fechanotif', 'cargo', 'editar', 'eliminar', 'seguimiento'];
  // matTableColumnsDef = ["item","nombre"];

  strCodTipoFicha: string = CodTipoFichaHe;
  strCodSubTipoFicha: string = CodSubTipoFichaDOC;
  numIdTipoFicha: number = null;

  constructor(protected catalogoService: CatalogoService,
              protected medioNotifService: MedioNotifService,
              public dialog: MatDialog) { }

  ngOnInit() {

    this.catalogoService.listarCatalogo(NumIdTipCatCargTipoDest).subscribe(data => {

      this.listTipoDestinatario = data;

    });

    this.medioNotifService.listarMedioNotif().subscribe(
      data => {

        this.listMedioNotif = data;

      });

    this.catalogoService.listarCatalogo(NumIdTipCatDocSeguimiento).subscribe(data => {

      // console.log("===========data");
      // console.log(data);

      this.listSeguimiento = data;

    });


  }

  _cargarTableMaterial() {

    setTimeout(() => {

      this.dataSource = new MatTableDataSource(this.listDocumentoDet);

      if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; }

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    }, 10);

  }

  _eliminarDoc(contratacion) {

    openModalMensajePrg('Documentos', strDscMsjPrgEliminar, this.dialog).subscribe(result => {

      // if(result != true)
      if (result == false) {

        this.listDocumentoDet.splice(this.listDocumentoDet.indexOf(contratacion), 1);

      }

    });

  }

  _cambioFechaGrilla(e: any) {

    let vStrFecha: string = e.target.value;
    const vCantCadena = vStrFecha.length;

    if (vCantCadena > 10) {

      vStrFecha = vStrFecha.substr(vCantCadena - 10);

    }

    e.target.value = vStrFecha;

  }

  setDocumentosEmitC(listDoc: DocumentoDet[]) {

    listDoc.forEach(element => {

      element.strDdocumentoFchemision = ConvertDateTimeToStr(element.ddocumentoFchemision);
      element.strDdocumentoFchnotif = ConvertDateTimeToStr(element.ddocumentoFchnotif);
      element.strDdocumentoFchrecep = ConvertDateTimeToStr(element.ddocumentoFchrecep);


    });

    this.listDocumentoDet = listDoc;

    this._cargarTableMaterial();

  }

  getDocumentosEmitC(flgGuardar: boolean) {

    if (flgGuardar) {

      this.listDocumentoDet.forEach(element => {

        element.strDdocumentoFchemision = ConvertStrDateToFormatBD(element.strDdocumentoFchemision);
        element.strDdocumentoFchnotif = ConvertStrDateToFormatBD(element.strDdocumentoFchnotif);
        element.strDdocumentoFchrecep = ConvertStrDateToFormatBD(element.strDdocumentoFchrecep);


      });

    }

    return this.listDocumentoDet;

  }

  setPushDocumentosEmitC(doc: DocumentoDet) {

    console.log('==================doc');
    console.log(doc);

    this.listDocumentoDet.push(doc);

    console.log('==================materual');


    this._cargarTableMaterial();

  }

  _verCargo(documentoDet: DocumentoDet) {

    const vIndex: number = this.listDocumentoDet.indexOf(documentoDet);

    console.log('========vIndex');
    console.log(vIndex);

    const dialogRef = this.dialog.open(ModalRegCargoComponent, { width: '75%', height: '75%',
    data: {documento : documentoDet, tipoFicha: this.strCodTipoFicha, subTipoFicha: CodSubTipoFichaCAR, numIdTipo: this.numIdTipoFicha}});

    dialogRef.afterClosed().subscribe(result => {

      console.log('=============result');

      console.log(result);

      this.listDocumentoDet[vIndex] = result;

    });

  }

}
